import React, { useMemo } from 'react';
import upperFirst from 'lodash/upperFirst';
import lowerFirst from 'lodash/lowerFirst';
import { Link, Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import Image from '../../../../../view/common/components/Image';
import { getNewBuildingLink } from '../../../../../view/selectors/get_new_building_link';
import {
    SearchOffersQuery$data as SearchOffersQueryResponse
} from '../../../../offer/search/page/SearchOffersQuery/__generated__/SearchOffersQuery.graphql';

import { useNewBuilding } from '../../../hooks/useNewBuilding';

import GalleryCapImage from './cap.url.png';

import './styles.css';

interface INewBuildingSnippet {
    newBuilding: SearchOffersQueryResponse['newBuilding'];
}

const cn = classname.bind(null, 'NewBuildingBaseSnippetMobile');

const NewBuildingBaseSnippet: React.FunctionComponent<INewBuildingSnippet> = ({
    newBuilding
}) => {
    const { routeParams, buildingStatus } = newBuilding ?? {};
    const { region, regionId, subRegion, type, name, id } = routeParams!;
    const { hero } = useNewBuilding(newBuilding);

    const url = useMemo(
        () => getNewBuildingLink({ region, regionId, subRegion, type, name, id }),
        [ region, regionId, subRegion, type, name, id ]
    );

    const staticPath = useStaticPathConfig();

    if (! newBuilding) {
        return null;
    }

    return (
        <div className={cn()}>
            { hero?.src ? (
                <Image
                    className={cn('image')}
                    type='cover'
                    url={hero.src}
                />
            ) : (
                <img
                    crossOrigin='anonymous'
                    alt='нет фотографии ЖК, заглушка'
                    src={`${staticPath}${GalleryCapImage}`}
                    className={cn('image', { empty: true })}
                />
            )}
            <div className={cn('content')}>
                <Link href={url}>
                    <Typography variant='primary-alone'>{newBuilding.title.nominative}</Typography>
                </Link>
                {
                    buildingStatus ? (
                        <Typography
                            variant='secondary'
                            color='secondary'
                        >
                            {upperFirst(buildingStatus.map(
                                ({ title } : { title: string }) => lowerFirst(title)).join(', '))}
                        </Typography>
                    ) : null
                }
            </div>
        </div>
    );
};

export default NewBuildingBaseSnippet;
